module.exports = __webpack_public_path__ + "europa-10-front.jpg?060cbb2c37b96b858c71fc24646687c2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-10-front.jpg
// module id = 242
// module chunks = 0